import Component from "vue-class-component";
import Vue from "vue";
import providers from "@/lib/providers";
import {
  InputUserCreate,
  InputUserDisable,
  InputUsersSearch,
  InputUserUpdate
} from "@teacherskaya/api-provider/dist/api/UserProvider";

@Component({ name: "WithUser" })
export default class WithUser extends Vue {

  public async userFindById(id: string) {
    let data = await providers.UserProvider.search({ data: { ids: [id] } });
    if (data.result.length === 0) throw new Error("user not found");
    return data.result[0];
  }

  public usersSearch({ data }: { data: InputUsersSearch }) {
    return providers.UserProvider.search({ data });
  }

  public userUpdate(data: InputUserUpdate) {
    return providers.UserProvider.update({ data });
  }

  public userAdd(data: InputUserCreate) {
    return providers.UserProvider.create({ data });
  }

  public userDelete(id: string) {
    return providers.UserProvider.delete({ id });
  }

  public userDisable(data: InputUserDisable) {
    return providers.UserProvider.disable({ data });
  }
}
